import { useState } from 'react'

import { PasswordVisibilityToggle } from '@/components/forms/password-visibility-toggle'
import { Input, type InputProps } from '@/components/forms/input'

export interface PasswordInputProps extends Omit<InputProps, 'suffix' | 'type'> {
  hideLabel?: string
  showLabel?: string
  showVisibilityToggle?: boolean
}

/**
 * 统一承载密码明文切换控件，保证密码输入框后缀的可访问性一致。
 * 文案由调用方传入，因为登录页需要跟随 i18n 切换。
 */
export function PasswordInput({
  hideLabel = 'Hide password',
  showLabel = 'Show password',
  showVisibilityToggle = true,
  ...props
}: PasswordInputProps) {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <Input
      {...props}
      type={showVisibilityToggle && isVisible ? 'text' : 'password'}
      suffix={
        showVisibilityToggle ? (
          <PasswordVisibilityToggle
            hideLabel={hideLabel}
            isVisible={isVisible}
            onToggle={() => {
              setIsVisible((value) => !value)
            }}
            showLabel={showLabel}
          />
        ) : undefined
      }
    />
  )
}
